import React from 'react'

const Artist = (props) => {
    let artist = props.artists.find(item => item.id === props.id)

    if(artist) {
        return (<span>{artist.name}</span>)
    } else {
        return (<span>Artist not found</span>)
    }
}

export default Artist


// WEBPACK FOOTER //
// ./src/components/artists/Artist.js